import { updateRequest } from '../../../../api'
import { useTableItemUpdate } from '../../../Table'

export function useRequestTableItemUpdate({ onAddNotification, onReload }) {
  const { updateItem } = useTableItemUpdate({
    api: updateRequest,
    onAddNotification,
    onReload,
  })

  async function handleChangeVisibility(id, data) {
    const errorText = data.visible_to_dwellers
      ? 'Notification.ServiceRequestMarkAsPublicErrorKey'
      : 'Notification.ServiceRequestMarkAsPrivateErrorKey'
    const successText = data.visible_to_dwellers
      ? 'Notification.ServiceRequestMarkedAsPublicKey'
      : 'Notification.ServiceRequestMarkedAsPrivateKey'

    return updateItem({
      data,
      errorText,
      id,
      successText,
    })
  }

  return { handleChangeVisibility }
}
